import { render } from "./recovery.vue?vue&type=template&id=486e475e&scoped=true"
import script from "./recovery.vue?vue&type=script&lang=js"
export * from "./recovery.vue?vue&type=script&lang=js"

import "./recovery.vue?vue&type=style&index=0&id=486e475e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486e475e"]])

export default __exports__